import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
    selector: 'a-button-delete',
    templateUrl: './a-button-delete.component.html',
    styleUrls: ['./a-button-delete.component.scss'],
    // tslint:disable-next-line:no-host-metadata-property
})
export class AButtonDeleteComponent implements OnInit {

    // Expanded host binding
    @HostBinding('class._expanded') isExpanded: boolean = false;

    @Input()
    public labelKey: string;

    @Input()
    public loading: false;

    @Input()
    public expanded: boolean = false;

    @Input()
    public disabled: boolean = false;

    ngOnInit(): void {
        if (this.expanded) {
            this.isExpanded = true;
        }
    }
}
